module.exports = __webpack_public_path__ + "img/vector-fields.aab9380e.png";